import React from "react";
import styled, { keyframes } from "styled-components";

const About = () => {
  return (
    <AboutContainer>
      <Section>
        <h1>Who We Are</h1>
        <p>
          Unfamiliar People is a movement dedicated to uplifting and empowering individuals across all walks of life.
          Our mission is to support those in need, champion important causes, and foster a world of equity and unity.
        </p>
      </Section>
      <Section>
        <h2>What We Do</h2>
        <p>
          From providing resources for struggling communities to advocating for systemic change, Unfamiliar People stands
          as a beacon of hope. We create programs, organize outreach efforts, and empower people to take meaningful
          action.
        </p>
      </Section>
    </AboutContainer>
  );
};

export default About;

// Styled Components
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const AboutContainer = styled.div`
  text-align: center;
  padding: 80px 20px;
  color: #000;
  background: #f9f9f9;
`;

const Section = styled.div`
  max-width: 800px;
  margin: 0 auto 50px;
  padding: 30px;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  animation: ${fadeIn} 1s ease-out;

  h1, h2 {
    font-size: 2.5rem;
    margin-bottom: 15px;
    font-weight: bold;
  }

  p {
    font-size: 1.2rem;
    line-height: 1.6;
  }
`;